var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6927 11.8107H9.25336V4.18937H10.6927C11.3609 4.18937 11.6955 3.38152 11.223 2.90902L8.5337 0.21968C8.24079 -0.0732266 7.76595 -0.0732266 7.47304 0.21968L4.7837 2.90902C4.31123 3.38149 4.64586 4.18937 5.31404 4.18937H6.75336V11.8107H5.31401C4.64583 11.8107 4.3112 12.6185 4.78367 13.091L7.47301 15.7804C7.76592 16.0733 8.24076 16.0733 8.53367 15.7804L11.223 13.091C11.6955 12.6186 11.3609 11.8107 10.6927 11.8107Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_162295_2422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 8,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6927 11.8107H9.25336V4.18937H10.6927C11.3609 4.18937 11.6955 3.38152 11.223 2.90902L8.5337 0.21968C8.24079 -0.0732266 7.76595 -0.0732266 7.47304 0.21968L4.7837 2.90902C4.31123 3.38149 4.64586 4.18937 5.31404 4.18937H6.75336V11.8107H5.31401C4.64583 11.8107 4.3112 12.6185 4.78367 13.091L7.47301 15.7804C7.76592 16.0733 8.24076 16.0733 8.53367 15.7804L11.223 13.091C11.6955 12.6186 11.3609 11.8107 10.6927 11.8107Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_162295_2422)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHeight);
export default __webpack_public_path__ + "static/media/arrow-height.978df02884221f779eb4341ec3fede88.svg";
export { ForwardRef as ReactComponent };